import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/pages/home/welcome_bonus';
import WelcomeSelector from '../../../selectors/modals/welcome_bonus';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import ModalsLib from '../../../lib/modals';
import Timer from './timer';
import {getWelcomeBonusTimestamp} from '../../../utils/user';



export default () => {
    const {isAuth} = useSelector(Selector),
          welcome_bonus = useSelector(WelcomeSelector),
          dispatch = useDispatch();

    if(!welcome_bonus.available)
        return <></>;

    return (
        <div className="deposit_bonus">
            <div className="layer"><div className="gift"></div></div>
            <div className="layer"><div className="gift"></div></div>
            <div className="layer details">
                <div className="left">
                    <div className="gift"></div>
                    <div className="text">
                        <div className="title">Get +{welcome_bonus.deposit}% to your first deposit</div>
                        <div className="descriptions">Make a deposit now and take a bonus of up to 1 000 USD to your deposit</div>
                    </div>
                </div>

                <div className="right">
                    <div className="button" onClick={e => {
                        if(isAuth)
                            dispatch(toggleActionModal('welcome-package'));
                            // ModalsLib.open('wallet')
                        else
                            ModalsLib.open('signup')
                    }}>Claim now</div>
                    <Timer timestamp={getWelcomeBonusTimestamp()} />
                </div>
            </div>
        </div>
    )
}